<template>
  <b-container>
    <b-card class="mt-4 mb-4">
      <standard-table ref="table"
                      :items="items"
                      :fields="fields"
                      :row-before-search="{cols: 12,sm: 12,md: 6,lg: 4,xl: 4,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 6,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 6, lg: 4, xl: 4, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"
                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 6, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 6, lg: 3, xl: 1}"

                      :sub-table-fields="subFields"
                      fullWidth="true"
                      noContainerPadding="true">
     <!--   <b-container slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button"
                        @click="$refs.table.excel($tc('message.trip', 1), customFields, itemsForExcel)">Excel
              </b-button>
            </b-col>
          </b-row>
        </b-container> -->

        <b-container slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="12" md="6" lg="6" xl="3">
                  <b-form-group :label="`${$tc('message.from', 1).toLowerCase()}`">
                    <b-input-group>
                      <flat-pickr id="start"
                                  ref="start"
                                  v-model="startFilter"
                                  @input="fetchData(null, startFilter, endFilter)"
                                  :config="startConfig">
                      </flat-pickr>

                      <div class="input-group-append">
                        <b-button class="fas fa-trash"
                                  :disabled="true">
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="6" xl="3">
                  <b-form-group :label="`${$tc('message.to', 1).toLowerCase()}`">
                    <b-input-group>
                      <flat-pickr id="end"
                                  ref="end"
                                  v-model="endFilter"
                                  @input="fetchData(null, startFilter, endFilter)"
                                  :config="endConfig">
                      </flat-pickr>

                      <div class="input-group-append">
                        <b-button class="fas fa-trash"
                                  :disabled="true">
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="6" xl="3">
                  <b-form-group :label="`${$tc('message.trip', 1)}`">
                    <v-select :options="tripOptions"
                              label="nome"
                              @input="tripFilter === null ? initDates() : fetchData(tripFilter, null, null)"
                              :placeholder="`${$tc('message.selectOption', 1)}`"
                              v-model="tripFilter">
                    </v-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container slot="row-after-search" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button @click="showCollapse = !showCollapse"
                        :class="showCollapse ? 'b-c-red mb-2 mr-2' : 'b-c-green mb-2 mr-2'" id="show-filters">
                <span v-show="!showCollapse"
                      class="when-opened">{{ $t('message.show') }} {{ $tc('message.filter', 2).toLowerCase() }}</span>
                <span v-show="showCollapse"
                      class="when-closed">{{ $t('message.hide') }} {{ $tc('message.filter', 2).toLowerCase() }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>
  </b-container>
</template>

<script>
import Vue from 'vue'
import _, { isNil } from 'lodash'
import { DateTime } from 'luxon'
import { Italian } from 'flatpickr/dist/l10n/it'

export default {
  name: 'ReportPresences',
  created () {
    this.fetchTripsName()
  },
  data () {
    const startFilter = DateTime.fromISO(new Date(new Date().setDate(new Date().getDate() - 7)).toISOString()).toISODate()
    const endFilter = `${DateTime.local().toISODate()}`

    return {
      startFilter,
      endFilter,
      firstDate: null,
      lastDate: null,
      yearNumber: null,
      items: [],
      tripOptions: [],
      tripFilter: null,
      fields: [
        {
          key: 'data',
          label: `${this.$tc('message.date', 1)}`,
          sortable: true,
          sortDirection: 'desc'
        },
        { key: 'gita', label: `${this.$tc('message.trip', 1)}`, sortable: true, sortDirection: 'desc' },
        { key: 'presences', label: '', sortable: true, sortDirection: 'desc' }
      ],
      subFields: [
        { key: 'bambino', label: `${this.$tc('message.child', 1)}`, sortable: true, sortDirection: 'desc' },
        { key: 'stato', label: `${this.$tc('message.status', 1)}`, sortable: true, sortDirection: 'desc' }
      ],
      customFields: [],
      itemsForExcel: [],
      datesString: [],
      showCollapse: true,
      startConfig: {
        dateFormat: 'Y-m-d',
        mode: 'single',
        altFormat: 'D j M Y',
        altInput: true,
        locale: Italian,
        minDate: null,
        maxDate: endFilter,
        disable: []
      },
      endConfig: {
        dateFormat: 'Y-m-d',
        mode: 'single',
        altFormat: 'D j M Y',
        altInput: true,
        locale: Italian,
        minDate: startFilter,
        maxDate: null,
        disable: []
      },
      choiceOk: false,
      childrenOfThisYear: [],
      tripStops: []
    }
  },
  methods: {
    fetchTripsName () {
      this.$root.$emit('activeLoader', true)
      Vue.myGet(this, '/bus/gita', 'gite').then((trips) => {
        trips.forEach(trip => {
          this.tripOptions.push({ data: trip.data, nome: trip.nome.trim(), id: trip.id })
        })
        Vue.myGet(this, '/bambino', 'bambini').then(async (children) => {
          children.forEach((child) => {
            this.childrenOfThisYear.push(child)
          })
          await this.fetchData()
          this.$root.$emit('activeLoader', false)
        }).catch(error => {
          Vue.manageErrors(this, error)
        })
      }).catch(error => {
        Vue.manageErrors(this, error)
      })
    },
    async fetchData (tripFilter, startFilter, endFilter) {
      if (!isNil(tripFilter)) {
        this.startFilter = null
        this.endFilter = null
      } else if (!isNil(startFilter) || !isNil(endFilter)) {
        this.tripFilter = null
      }
      this.$root.$emit('activeLoader', true)
      let url = '/bus/presenze?'
      if (!isNil(this.startFilter)) {
        url += 'da=' + this.startFilter + '&'
      }
      if (!isNil(this.endFilter)) {
        url += 'a=' + this.endFilter + '&'
      }
      if (!isNil(this.tripFilter)) {
        url += 'gita=' + this.tripFilter.id
      }
       await Vue.myGet(this, url, 'presenze').then((presences) => {
          this.items = []
         const items = []
          presences.forEach((tripInformation) => {
            const foundedTrip = _.find(this.tripOptions, (trip) => trip.id === tripInformation.id_gita)
            const newItem = {
              gita: !isNil(foundedTrip)
                  ? foundedTrip.nome
                  : '',
              data: !isNil(foundedTrip)
                  ? foundedTrip.data
                  : '',
              children: [],
              toggleDetails: true
            }
            tripInformation.bambini.forEach((child) => {
              const foundedChild = _.find(this.childrenOfThisYear, item => item.id === child.id_bambino)
              const newSubItem = {}
              if (!isNil(foundedChild)) {
                newSubItem.bambino = foundedChild.nome + ' ' + foundedChild.cognome
              }
              if (child.presenza_effettiva === true) {
                newSubItem.stato = this.$tc('message.present', 1)
              } else {
                newSubItem.stato = this.$tc('message.absent', 1)
              }
              newItem.children.push(newSubItem)
            })
            items.push(newItem)
          })
         console.log(items)
          this.items = this.sortFormattedDate(items)
          this.$root.$emit('activeLoader', false)
        })
    },
    formatDate (date) {
      const day = new Date(date).getDate().toString().length === 1 ? '0' + new Date(date).getDate().toString() : new Date(date).getDate().toString()
      const month = (new Date(date).getMonth() + 1).toString().length === 1 ? '0' + (new Date(date).getMonth() + 1).toString() : (new Date(date).getMonth() + 1).toString()
      const year = new Date(date).getFullYear()
      return day + '/' +
          month + '/' +
          year
    },
    sortFormattedDate (items) {
      return items.sort(function (firstDate, secondDate) {
        const firstDateArray = firstDate.data.split('/')
        const convertFirstDateArray = new Date(firstDateArray[2] + '/' + firstDateArray[1] + '/' + firstDateArray[0])
        const secondDateArray = secondDate.data.split('/')
        const convertSecondDateArray = new Date(secondDateArray[2] + '/' + secondDateArray[1] + '/' + secondDateArray[0])
        return new Date(convertFirstDateArray) - new Date(convertSecondDateArray)
      })
    },
    initDates () {
      this.startFilter = DateTime.fromISO(new Date(new Date().setDate(new Date().getDate() - 7)).toISOString()).toISODate()
      this.endFilter = `${DateTime.local().toISODate()}`
    },
    getDatesInRange (startDate, endDate) {
      const date = new Date(startDate.getTime())

      const dates = []

      // eslint-disable-next-line no-unmodified-loop-condition
      while (date <= endDate) {
        dates.push(new Date(date))
        date.setDate(date.getDate() + 1)
      }

      return dates
    }
  },
  watch: {
    startFilter () {
      this.endConfig.minDate = this.startFilter
    },
    endFilter () {
      this.startConfig.maxDate = this.endFilter
    }
  }
}
</script>

<style scoped>

</style>
